<template>
    <div>
        <!-- 生成二维码弹出框 -->
        <el-tabs type="border-card">
            <el-tab-pane label="中医问诊">
                <div class="item">
                    <div class="l1">
                        <div v-if="chineseQrcodeImgUrl" class="qrcode chinese" ref="qrcode">
                            <img class="bg" src="@/assets/img/chineseBg.jpg" alt="">
                            <img :src="chineseQrcodeImgUrl" class="avatar">
                        </div>
                        <div class="qrcodeBtn">
                            <el-button type="primary" v-if="chineseQrcodeImgUrl" @click="downloadQrcode('.chinese')">下载二维码</el-button>
                        </div>
                    </div>
                    <div>
                        <div v-if="chineseQrcodeImgUrl" class="bgShare chineseShare" ref="qrcode">
                            <img class="bg" src="@/assets/img/chineseShare.jpg" alt="">
                            <img :src="chineseQrcodeImgUrl" class="avatar chineseShareCode">
                        </div>
                        <div class="qrcodeBtn">
                            <el-button type="primary" v-if="chineseQrcodeImgUrl" @click="downloadQrcode('.chineseShare')">下载二维码</el-button>
                        </div>
                    </div>
                </div>
                <div class="qrcodeBtn">
                    <!-- <el-button type="primary" v-if="chineseQrcodeImgUrl" @click="downloadQrcode">下载二维码</el-button> -->
                    <el-button type="primary" @click="getToolCode(1)" v-if="!chineseQrcodeImgUrl">生成二维码</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="并发症评估">
                <div class="item">
                    <div class="l1">
                        <div v-if="complicationQrcodeImgUrl" class="qrcode complicationBg" ref="qrcode">
                            <img class="bg" src="@/assets/img/complicationBg.jpg" alt="">
                            <img :src="complicationQrcodeImgUrl" class="avatar comCode">
                        </div>
                        <div class="qrcodeBtn">
                            <el-button type="primary" v-if="complicationQrcodeImgUrl" @click="downloadQrcode('.complicationBg')">下载二维码</el-button>
                        </div>
                    </div>
                    <div>
                        <div v-if="complicationQrcodeImgUrl" class="bgShare complicationShare" ref="qrcode">
                            <img class="bg" src="@/assets/img/complicationShare.jpg" alt="">
                            <img :src="complicationQrcodeImgUrl" class="avatar complicationShareCode">
                        </div>
                        <div class="qrcodeBtn">
                            <el-button type="primary" v-if="complicationQrcodeImgUrl" @click="downloadQrcode('.complicationShare')">下载二维码</el-button>
                        </div>
                    </div>
                </div>

                <div class="qrcodeBtn">
                    <!-- <el-button type="primary" v-if="complicationQrcodeImgUrl" @click="downloadQrcode('.qrcode')">下载二维码</el-button> -->
                    <el-button type="primary" @click="getToolCode(2)" v-if="!complicationQrcodeImgUrl">生成二维码</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="专属医生">
                <div class="item">
                    <div class="l1">
                        <div>

                            <div v-if="exclusiveQrcodeImgUrl" class="qrcode doctorBg" ref="qrcode">
                                <img class="bg" src="@/assets/img/doctorBg.jpg" alt="">
                                <img :src="exclusiveQrcodeImgUrl" class="avatar docCode">
                            </div>
                            <div class="qrcodeBtn">
                                <el-button type="primary" v-if="exclusiveQrcodeImgUrl" @click="downloadQrcode('.doctorBg')">下载二维码</el-button>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div>

                            <div v-if="exclusiveQrcodeImgUrl" class="bgShare doctorShare" ref="qrcode">
                                <img class="bg" src="@/assets/img/doctorShare.jpg" alt="">
                                <img :src="exclusiveQrcodeImgUrl" class="avatar doctorShareCode">
                            </div>
                            <div class="qrcodeBtn">
                                <el-button type="primary" v-if="exclusiveQrcodeImgUrl" @click="downloadQrcode('.doctorShare')">下载二维码</el-button>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="qrcodeBtn">
                    <el-button type="primary" @click="getToolCode(3)" v-if="!exclusiveQrcodeImgUrl">生成二维码</el-button>
                </div>
            </el-tab-pane>

            <el-tab-pane label="O2O商城">
                <div class="item">
                    <div class="l1">
                        <div v-if="o2oQrcodeImgUrl" class="qrcode otoBg" ref="qrcode">
                            <img class="bg" src="@/assets/img/otoBg.jpg" alt="">
                            <img :src="o2oQrcodeImgUrl" class="avatar otoCode">
                        </div>
                        <div class="qrcodeBtn">
                            <el-button type="primary" v-if="o2oQrcodeImgUrl" @click="downloadQrcode('.otoBg')">下载二维码</el-button>
                        </div>
                    </div>
                    <div>
                        <div v-if="o2oQrcodeImgUrl" class="bgShare otoShare" ref="qrcode">
                            <img class="bg" src="@/assets/img/otoShare.png" alt="">
                            <img :src="o2oQrcodeImgUrl" class="avatar otoShareCode">
                        </div>
                        <div class="qrcodeBtn">
                            <el-button type="primary" v-if="o2oQrcodeImgUrl" @click="downloadQrcode('.otoShare')">下载二维码</el-button>
                        </div>
                    </div>
                </div>
                <div class="qrcodeBtn">

                    <el-button type="primary" @click="getToolCode(4)" v-if="!o2oQrcodeImgUrl">生成二维码</el-button>
                </div>
            </el-tab-pane>

            <el-tab-pane label="绑定设备">
                <div class="item">
                    <div class="l1">
                        <div>
                            <div v-if="bindDeviceQrcodeImgUrl" class="qrcode bindDeviceBg" ref="qrcode">
                                <img class="bg" src="@/assets/img/bindDeviceBg.png" alt="">
                                <!-- <div class="bindDevice-container">
                                    <img :src="bindDeviceQrcodeImgUrl" class="bindDeviceQr">
                                </div> -->
                                <img :src="bindDeviceQrcodeImgUrl" class="avatar bindDeviceQr">

                            </div>
                            <div class="qrcodeBtn">
                                <el-button type="primary" v-if="bindDeviceQrcodeImgUrl" @click="downloadQrcode('.bindDeviceBg')">下载二维码</el-button>
                            </div>
                        </div>
                    </div>

                    <!-- <div>
                        <div>
                            <div v-if="bindDeviceQrcodeImgUrl" class="bgShare doctorShare" ref="qrcode">
                                <img class="bg" src="@/assets/img/doctorShare.jpg" alt="">
                                <img :src="bindDeviceQrcodeImgUrl" class="avatar doctorShareCode">
                            </div>
                            <div class="qrcodeBtn">
                                <el-button type="primary" v-if="bindDeviceQrcodeImgUrl" @click="downloadQrcode('.doctorShare')">下载二维码</el-button>
                            </div>
                        </div>
                    </div> -->

                </div>

                <div class="qrcodeBtn">
                    <el-button type="primary" @click="getToolCode(5)" v-if="!bindDeviceQrcodeImgUrl">生成二维码</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcodejs2'
import { setTimeout } from 'timers';
export default {
    props: {
        showQrcode: {
            default: false,
            type: Boolean
        },
        qrCodeForm: {
            default: { enterpriseId: '', storeId: '' },
            type: Object
        }
    },
    data() {
        return {
            chineseQrcodeImgUrl: '',
            complicationQrcodeImgUrl: '',
            exclusiveQrcodeImgUrl: '',
            o2oQrcodeImgUrl: '',
            bindDeviceQrcodeImgUrl: '',
            id: ''
        }
    },
    watch: {
        showQrcode() {
            if (this.showQrcode) {
                this.onLookQrcode();
            }
        }
    },
    methods: {
        // 下载二维码
        downloadQrcode(name) {
            let _this = this;
            setTimeout(() => {
                let targetDom = document.querySelector(name);
                console.log(targetDom)
                html2canvas(targetDom, {
                    logging: true,
                    scrollY: -5, //  为了解决顶部偏移出现白边，初始化时就直接设置往上偏移-20位置
                    scrollX: 0,
                    dpi: 300,
                    scale: 6,
                    allowTaint: false,
                    useCORS: true		// 运行跨域图片资源d
                }).then(function (canvas) {
                    var image = canvas.toDataURL('image/jpeg');
                    let posterBase64 = image;
                    _this.$nextTick(() => {
                        var $a = document.createElement('a');
                        $a.href = posterBase64;
                        $a.download = '二维码';
                        $a.click();
                    })
                });
            }, 1000)
        },
        onLookQrcode(row) {
            console.log(row);
            if (this.qrCodeForm.storeId != this.id) {
                this.chineseQrcodeImgUrl = '';
                this.complicationQrcodeImgUrl = '';
                this.exclusiveQrcodeImgUrl = '';
                this.o2oQrcodeImgUrl = '';
                this.bindDeviceQrcodeImgUrl = '';
            }
            this.id = this.qrCodeForm.storeId;
            this.showQrcode = true;
            // if ()
        },
        // 生成二维码  二维码类型codeType(1-中医检查，2-并发症评估，3-在线医生，4-O2O)
        getToolCode(codeType) {
            // if (codeType == 4) {
            //     this.qrCodeForm.enterpriseId = 145;
            //     this.qrCodeForm.storeId = 3522;
            // }
            this.$https.get('system/store/getToolCode', { enterpriseId: this.qrCodeForm.enterpriseId, storeId: this.qrCodeForm.storeId, codeType: codeType }).then(res => {
                if (res.code == 200) {
                    this.$message.success('生成成功');
                    console.log(res.data)
                    if (codeType == 1) {
                        this.chineseQrcodeImgUrl = res.data;
                    } else if (codeType == 2) {
                        this.complicationQrcodeImgUrl = res.data;
                    } else if (codeType == 3) {
                        this.exclusiveQrcodeImgUrl = res.data;
                    } else if (codeType == 4) {
                        this.o2oQrcodeImgUrl = res.data;
                    } else if (codeType == 5) {
                        this.bindDeviceQrcodeImgUrl = res.data;
                    }
                    // this.form.storeAppletQrcodeImgUrl = res.data || '';
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
    }
}
</script>
<style lang="less" scoped>
.item {
    display: flex;
    .l1 {
        margin-right: 20px;
    }
}
.qrcode {
    width: 480px;
    height: 678px;
    position: relative;
    margin: 0 auto;
    .bg {
        width: 100%;
        height: 100%;
    }
    .avatar {
        position: absolute;
        border-radius: 50%;
        width: 65px;
        height: 65px;
        bottom: 118px;
        left: 207px;
    }
}
.bgShare {
    .bg {
        width: 100%;
        height: 100%;
    }
    .avatar {
        position: absolute;
        border-radius: 50%;
    }
}
.chineseShare {
    width: 480px;
    height: 951px;
    position: relative;
    margin: 0 auto;
    .chineseShareCode {
        width: 125px;
        height: 125px;
        bottom: 50px;
        left: 89px;
    }
}
.complicationBg {
    width: 480px;
    height: 1026px;

    .comCode {
        width: 130px;
        height: 130px;
        bottom: 78px;
        left: 109px;
    }
}
.complicationShare {
    width: 480px;
    height: 678px;
    position: relative;
    margin: 0 auto;
    .complicationShareCode {
        width: 110px;
        height: 110px;
        bottom: 96px;
        left: 113px;
    }
}
.doctorBg {
    width: 480px;
    height: 678px;
    .docCode {
        width: 110px;
        height: 110px;
        bottom: 80px;
        left: 96px;
    }
}
.otoBg {
    width: 480px;
    height: 678px;
    .otoCode {
        width: 110px;
        height: 110px;
        // bottom: 67px;
        bottom: 108px;
        left: 185px;
    }
}
.bindDeviceBg {
    .bindDevice-container {
        width: 110px;
        height: 110px;
        bottom: 418px;
        left: 190px;
        position: relative;
        // background-color: #fff;
        border: 1px black solid;
        border-radius: 50%;
        box-shadow: red;
        .bindDeviceQr {
            width: 100%;
            height: 100%;
        }
    }
    .bindDeviceQr {
        width: 110px;
        height: 110px;
        bottom: 418px;
        left: 190px;
        position: relative;
        // border: 10px black solid;
        box-shadow: 8px 8px 20px rgb(231, 170, 152);
    }
}
.doctorShare {
    width: 480px;
    height: 678px;
    position: relative;
    margin: 0 auto;
    .doctorShareCode {
        width: 70px;
        height: 70px;
        bottom: 13px;
        left: 241px;
    }
}
.otoShare {
    width: 480px;
    height: 853px;
    position: relative;
    margin: 0 auto;
    .otoShareCode {
        width: 130px;
        height: 130px;
        bottom: 47px;
        left: 61px;
    }
}
.qrcodeBtn {
    text-align: center;
    margin-top: 10px;
}
</style>


